import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class DateUtilsService {

  getCurrentDateFormatted(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  formatTime(milliseconds: number): string {
    const totalSeconds = Math.abs(Math.floor(milliseconds / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  convertTimeStringToValidDate(timeString: string): Date | null {
    if (!timeString) return null;
    const currentDate = new Date();
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    currentDate.setHours(hours, minutes, seconds || 0, 0);
    return currentDate;
  }

  convertTimeStringToMs(timeString: string): number {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return ((hours * 60 + minutes) * 60 + (seconds || 0)) * 1000;
  }

  convertMsToTimeString(ms: number) {
    let totalMinutes = Math.floor(ms / (1000 * 60));
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  }


  extractTimeFromTimeStamp(timestamp: number): string {
    let date = new Date(timestamp);
    return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
  }

  calculateDelta(statusTime: number, currentTime: number, taktTime: number): number {
    return taktTime + statusTime - currentTime;
  }

  calculateDeltaFormatted(saida: string): string {
    const now = new Date();
    const saidaDate = this.convertTimeStringToValidDate(saida);
    if (!saidaDate) return '--:--:--';
    let diffInMs = saidaDate.getTime() - now.getTime();
    const isLate = diffInMs < 0;
    const formatted = this.formatTime(Math.abs(diffInMs));
    return isLate ? `-${formatted}` : formatted;
  }

  calculateDifference(start: string, end: string): string {
    const endTime = this.convertTimeStringToValidDate(end);
    const startTime = this.convertTimeStringToValidDate(start);

    if (!startTime || !endTime) return ' ';

    if (endTime.getTime() < startTime.getTime()) endTime.setDate(endTime.getDate() + 1);

    const diffInMs = endTime.getTime() - startTime.getTime();
    const diffInHours = Math.floor(diffInMs / (60 * 60 * 1000));
    const diffInMinutes = Math.floor((diffInMs % (60 * 60 * 1000)) / (60 * 1000));
    const diffInSeconds = Math.floor((diffInMs % (60 * 1000)) / 1000);

    return `${String(diffInHours).padStart(2, '0')}:${String(diffInMinutes).padStart(2, '0')}:${String(diffInSeconds).padStart(2, '0')}`;
  }

  formatTimeToJsDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    }).substring(12);
  }

  getTimeOfDayInMs(date: Date): number {
  return date.getHours() * 3600000 + date.getMinutes() * 60000 + date.getSeconds() * 1000;
}

}
